import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';
import '../../main.css';

function ContactUs(){

  const navigate = useNavigate();  // ایجاد یک instance از useNavigate برای هدایت به صفحات دیگر

  // تابعی برای هدایت به صفحه جدید
  const goToUploadImage = () => {
    navigate("/UploadImage");  // آدرس صفحه‌ای که می‌خواهید به آن هدایت شوید
  };
  const goToInvoiceForm = () => {
    navigate("/InvoiceForm");  // آدرس صفحه‌ای که می‌خواهید به آن هدایت شوید
  };

return (

  <div>

<Helmet>
        <title>تماس با ما - سیستم یکپارچه مالی راینو</title>
        <meta name="description" content="با ما در تماس باشید. سوالات و نظرات خود را برای ما ارسال کنید." />
        <meta name="keywords" content="تماس با ما, نظرات, سوالات , راینو" />
</Helmet>


<section className="py-4 bg-light title">

   <div className="container">
     <div className="row">
        <div className="col-md-4 my-auto">
        <h3 className="float-end"> تماس با ما </h3>
        </div>

      </div>
     </div>

</section>


<section className="section">


<div className="container">
   <div className="card shadow">
     <div className="card-body">
         
         <div className="row">
              <div className="col-md-6">
               <h4>فرم ارتباط با ما</h4>
               <hr/>

                 <div className="form-group">
                 <label className="mb-1">نام خانوادگی: </label> 
                 <input type="text" className="form-control" placeholder="نام خانوادگی را وارد کنید" />
                 </div>

                 <div className="form-group">
                 <label className="mb-1">شماره تماس: </label> 
                 <input type="text" className="form-control" placeholder="شماره تماس را وارد کنید" />
                 </div>

                 <div className="form-group">
                 <label className="mb-1">ایمیل: </label> 
                 <input type="text" className="form-control" placeholder="ایمیل را وارد کنید" />
                 </div>

                 <div className="form-group">
                 <label className="mb-1">متن پیام : </label> 
                 <textarea rows="3" className="form-control" placeholder="پیام خود را وارد کنید"></textarea>
                 </div>                                               

                 <div className="form-group py-3">
                 <button type="button" className="btn btn-primary shadow w-100">ارسال پیام</button>
                 </div>  

              </div>





  <div className="col-md-6 border-end">
  <h5 className="main-heading">شرکت فنی مهندسی پویارایانه فرتاک </h5>
  <div className="underline"></div>
  <p>آدرس دفتر اهواز :</p>
  <p>امانیه نبش خیابان بوعلی ساختمان سیمرغ طبقه 1 واحد 1</p>

  <p>آدرس دفتر دزفول :</p>
  <p>خیابان آفرینش بین شیخ بهایی و دهقان طبقه 2 واحد 4 دفتر راینو دزفول </p>
  <p></p>
  


  <p className="text-left">09120676042</p>
  <p className="text-left">09163449967</p>
  <p className="text-left">09169129967</p>
  <p className="text-left">06142249791</p>
  <p className="text-left">06142249855</p>
  <p className="text-left">
    Email: Info@RAYNOGroup.com
  </p>   
  <div className="text-start">
    <button
            onClick={goToUploadImage} // هنگام کلیک هدایت به صفحه جدید
            className="btn btn-primary mt-4"
          >
            /
  </button>


  <button
            onClick={goToInvoiceForm} // هنگام کلیک هدایت به صفحه جدید
            className="btn btn-primary mt-4"
          >
           /
  </button>    
  </div>

</div>




         </div>
          
     </div>
   </div>
</div>

</section>


</div>
    )

}

export default ContactUs;